module.exports = __webpack_public_path__ + "img/weibo_Code.0c405970.png";